module.exports = __webpack_public_path__ + "static/colorbills-icon-2852d81fb6f856e527e184abd8518f7c.png";